export enum LicenseDeviceStatusEnum {
  InUse = 'In Use',
}